// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.alert-chart-container[data-v-35a8f301] {
  max-width: unset !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  height: 100%;
  width: 100%;
}
.alert-chart-container .group-info[data-v-35a8f301] {
  font-style: italic;
  white-space: nowrap;
}
.alert-chart-container-wrapper[data-v-35a8f301] {
  max-width: unset !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
}
.chart-title[data-v-35a8f301] {
  font-weight: 600;
  font-size: 14px;
  color: var(--filter-text-color);
  padding: 14px 20px;
  background-color: var(--panel-background);
}
.alert-chart-container-title[data-v-35a8f301] {
  font-weight: bold;
  font-size: 12px;
  color: var(--filter-text-color);
  padding: 0 0 0 44px;
}`, "",{"version":3,"sources":["webpack://./js/modules/assurance/components/moi-alert-chart/alertChart.vue","webpack://./alertChart.vue"],"names":[],"mappings":"AACA;EACE,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;EAEA,aAAA;EACA,YAAA;EACA,WAAA;ACDF;ADGE;EACE,kBAAA;EACA,mBAAA;ACDJ;ADMA;EACE,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;EAEA,aAAA;ACJF;ADOA;EACE,gBAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,yCAAA;ACJF;ADOA;EACE,iBAAA;EACA,eAAA;EACA,+BAAA;EACA,mBAAA;ACJF","sourcesContent":["\n.alert-chart-container {\n  max-width: unset!important;\n  margin-left: 0!important;\n  margin-right: 0!important;\n  padding-top: 0;\n  padding-bottom: 0;\n\n  margin-top: 0;\n  height: 100%;\n  width: 100%;\n\n  .group-info {\n    font-style: italic;\n    white-space: nowrap;\n  }\n\n}\n\n.alert-chart-container-wrapper {\n  max-width: unset!important;\n  margin-left: 0!important;\n  margin-right: 0!important;\n  padding-top: 0;\n  padding-bottom: 0;\n\n  margin-top: 0;\n}\n\n.chart-title {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--filter-text-color);\n  padding: 14px 20px;\n  background-color: var(--panel-background);\n}\n\n.alert-chart-container-title {\n  font-weight: bold;\n  font-size: 12px;\n  color: var(--filter-text-color);\n  padding: 0 0 0 44px;\n}\n",".alert-chart-container {\n  max-width: unset !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  height: 100%;\n  width: 100%;\n}\n.alert-chart-container .group-info {\n  font-style: italic;\n  white-space: nowrap;\n}\n\n.alert-chart-container-wrapper {\n  max-width: unset !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n}\n\n.chart-title {\n  font-weight: 600;\n  font-size: 14px;\n  color: var(--filter-text-color);\n  padding: 14px 20px;\n  background-color: var(--panel-background);\n}\n\n.alert-chart-container-title {\n  font-weight: bold;\n  font-size: 12px;\n  color: var(--filter-text-color);\n  padding: 0 0 0 44px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
